import { Type } from "../Type";
export function union(...types) {
    return new IslyUnion(...types);
}
export class IslyUnion extends Type {
    class = "union";
    types;
    constructor(...types) {
        super(() => types.map(type => type.name).join(" | "));
        this.types = types;
    }
    is = (value) => this.types.some(type => type.is(value));
    createFlaw(value) {
        return {
            flaws: this.types.map(type => type.flaw(value)).filter(flaw => flaw),
        };
    }
    getValue(value) {
        return this.types.find(type => type.is(value))?.get(value);
    }
}
//# sourceMappingURL=index.js.map